import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-callc_place",
  "use": "icon-callc_place-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol viewBox=\"0 0 36 36\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-callc_place\"><clipPath id=\"icon-callc_place_a\"><path d=\"m0 0h36v36h-36z\" /></clipPath><g clip-path=\"url(#icon-callc_place_a)\"><path d=\"m10 26-4 4 4 4\" fill=\"none\" stroke=\"#4bd214\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" /><g fill=\"#4bd214\"><path d=\"m16.796 11.506h1.456v2.1h5.782v1.386h-5.782v2.352h4.774v7.112h-1.442v-.812h-7.14v.826h-1.442v-7.126h3.794zm-2.352 10.752h7.14v-3.514h-7.14z\" /><path d=\"m5 22c0 .552.448 1 1 1s1-.448 1-1zm7-15h12v-2h-12zm17 5v12h2v-12zm-22 10v-10h-2v10zm17 7h-17v2h17zm5-5c0 2.761-2.239 5-5 5v2c3.866 0 7-3.134 7-7zm-5-17c2.761 0 5 2.239 5 5h2c0-3.866-3.134-7-7-7zm-12-2c-3.866 0-7 3.134-7 7h2c0-2.761 2.239-5 5-5z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/callc_place.svg
// module id = 2UAG
// module chunks = 87